import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

import { TrackedPropertyRelationship } from '../../graphql.generated';

import { useTrackPropertyContext } from '../context/track-property-context';
import type { PropertyDataForAnalytics } from '@zoopla/analytics/property-data';

import { recordDismissModal, recordSaveRelationship } from '../tracking';

const SAVE_TRACKED_PROPERTY = gql`
    mutation saveTrackedProperty($trackedProperty: TrackedPropertyInput!) {
        saveTrackedProperty(trackedProperty: $trackedProperty)
    }
`;

export const useSaveRelationship = (
    analyticsData: PropertyDataForAnalytics,
    updateIsRelationshipModalShowing: (open: boolean) => void,
    isEditing = false
) => {
    const {
        dispatch,
        state: { relationship }
    } = useTrackPropertyContext();

    const existingRelationship = relationship;

    const [
        saveTrackedProperty,
        { loading: saveRelationshipLoading, error: saveRelationshipError }
    ] = useMutation(SAVE_TRACKED_PROPERTY);

    const { uprn } = analyticsData;

    const saveAndCloseRelationshipModal = async (
        relationship: TrackedPropertyRelationship
    ) => {
        try {
            await saveTrackedProperty({
                variables: {
                    trackedProperty: {
                        uprn,
                        relationship
                    }
                }
            });
        } catch (e) {
            dispatch({ type: 'error' });
            return;
        }
        dispatch({ type: 'saveRelationship', relationship });
        updateIsRelationshipModalShowing(false);
        recordSaveRelationship(
            analyticsData,
            relationship,
            existingRelationship,
            isEditing
        );
    };

    const dismissRelationshipModal = () => {
        if (!relationship) {
            dispatch({ type: 'trackProperty' });
        }

        updateIsRelationshipModalShowing(false);
        recordDismissModal(analyticsData, existingRelationship, isEditing);
    };

    return {
        dismissRelationshipModal,
        saveAndCloseRelationshipModal,
        relationship,
        saveRelationshipLoading,
        saveRelationshipError
    };
};
